// src/App.tsx
import { Suspense } from "react";
import { Routes } from "@/routes";
import { LoadingPage } from "@/components/common/loading";
import { Toaster } from "sonner";
import { useBrandSettings } from "@/hooks/use-brand-settings";

function App() {
  useBrandSettings();

  return (
    <div className="bg-[#F6F6F6]">
      <Suspense fallback={<LoadingPage />}>
        <Routes />
      </Suspense>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
